import CommonErrorPage from "./Common/CommonErrorPage";

const Error401 = () => {
  return <CommonErrorPage color="warning" page="401" />;
};

export default Error401;
